<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="12" cy="5" r="3"></circle>
    <path d="M6.5 8a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2v-10a2 2 0 0 0-2-2h-11z"></path>
    <path d="M10 14l-2 2 2 2"></path>
    <path d="M14 14l2 2-2 2"></path>
  </svg>
</template>

<script setup>
</script>